/**
 * Query to fetch marketplace_seller_feature records for a seller
 */
const sellerFeaturesQuery = `
query GetSellerFeatures($where: Marketplace_seller_featureWhereInput) {
  marketplace_seller_features(first: 1000, where: $where) {
    edges {
      node {
        objectId
        enabled
        feature_pointer {
          objectId
          name
          label
          description
          plans { ... on Element { value } }
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default sellerFeaturesQuery;
